import axios from "axios";
import { createContext, useContext, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { BASE_API } from "../../../constants/api";
import { errorNotify } from "../../../shared/notifications";
import { persianLanguage } from "../../../constants/persianTerms";
import { invalidateRefresh, validAccess, clearCredentials } from "../token-session";
const AuthContext = createContext();

const AuthProvider = ({children}) => {
    const tokenApi = `${BASE_API}token/`;
    const loginAPI = `${BASE_API}login/`;

    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);
    const [token, setToken] = useState(localStorage.getItem('token') || '' );
    const navigate = useNavigate();
    useEffect(() => {
        const sync = () => {
            setToken(localStorage.getItem('token') || '');
            setUser(JSON.parse(localStorage.getItem('user') || 'null'));
        };
        window.addEventListener('auth-credentials-changed', sync);
        window.addEventListener('storage', sync);
        return () => {
            window.removeEventListener('auth-credentials-changed', sync);
            window.removeEventListener('storage', sync);
        };
    }, []);

    const tokenLoginAction = (data) => {
        axios.post(tokenApi, data).then(
            (response) => {
                const user = {
                    'id': response.data.id,
                    'fullName': response.data.fullName,
                    'userType': response.data.userType,
                    'expiresIn': response.data.expiresIn,
                    'isAdmin': response.data.isAdmin,
                    'isSysAdmin': response.data.isSysAdmin,
                };
                setUser(user);
                invalidateRefresh();
                localStorage.setItem('refreshToken', response.data.refresh);
                setToken(response.data.access);
                localStorage.setItem('token', response.data.access)
                localStorage.setItem('user', JSON.stringify(user))
                navigate("/");
            }
        ).catch(
            (error) => {
                if(error.response){
                    if(error.response.status === 400){
                        errorNotify(persianLanguage.phrase.error.ERROR_400);
                    } else if(error.response.status === 401){
                        errorNotify(persianLanguage.phrase.error.ERROR_401);
                    } else if(error.response.status === 403){
                        errorNotify(persianLanguage.phrase.error.ERROR_403);
                    }else if(error.response.status === 404){
                        errorNotify(persianLanguage.phrase.error.ERROR_404);
                    }
                }

            }
        );
    }

    const loginAction = async (data) => {
        return axios.post(loginAPI, data).then(
            (response) => {
                const user = {
                    'id': response.data.id,
                    'fullName': response.data.fullName,
                    'firstName': response.data.firstName,
                    'lastName': response.data.lastName,
                    'hasName': response.data.hasName,
                    'userType': response.data.userType,
                    'expiresIn': response.data.expiresIn,
                    'profileId': response.data.profileId,
                    'profileCode': response.data.profileCode,
                    'isAdmin': response.data.isAdmin,
                    'isSysAdmin': response.data.isSysAdmin,
                };
                navigate("/");
                setUser(user);
                invalidateRefresh();
                localStorage.setItem('refreshToken', response.data.refresh);
                setToken(response.data.access);
                localStorage.setItem('token', response.data.access)
                localStorage.setItem('user', JSON.stringify(user));
                return response;
            }
        ).catch(
            (error) => {
                return Promise.reject(error); // ✅ return rejection properly
            }
        );
    }

//     const logout = () => {
//         navigate("/login/");
//         setUser(null);
//         setToken("");
//         localStorage.removeItem("profilePopupDismissed");
//         localStorage.removeItem('user');
//         localStorage.removeItem('token');
//     }
//     const logout = async () => {
//         const accessToken = localStorage.getItem('token') || token;
//         try {
//             if (accessToken) {
//                 await axios.post(`${BASE_API}logout/`, {}, {
//                     headers: { Authorization: `Bearer ${accessToken}` },
//                     timeout: 10000,
//                 });
//             }
//         } catch (error) {
//             if (error?.response?.status !== 401) {
//                 errorNotify("خروج از حساب در این مرورگر انجام شد، اما بستن نشست در سرور ناموفق بود.");
//             }
//         } finally {
//             navigate("/login/");
//             setUser(null);
//             setToken("");
//             localStorage.removeItem("profilePopupDismissed");
//             localStorage.removeItem('user');
//             localStorage.removeItem('token');
//         }
//     }
    const logout = async () => {
        const accessToken = localStorage.getItem('token') || token;
        if (!accessToken) {
            errorNotify("خروج از حساب ناموفق بود. لطفاً دوباره تلاش کنید.");
            return;
        }
        try {
            const currentAccess = await validAccess({ preserveCredentialsOnFailure: true });
            await axios.post(`${BASE_API}logout/`, {}, {
                headers: { Authorization: `Bearer ${currentAccess}` },
                timeout: 10000,
            });
        } catch (error) {
            errorNotify("خروج از حساب ناموفق بود. لطفاً دوباره تلاش کنید.");
            return;
        }
        clearCredentials();
        navigate("/login/");
        setUser(null);
        setToken("");
        localStorage.removeItem("profilePopupDismissed");
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    }

    return (
        <>
            <AuthContext.Provider 
            value={{user, 
            tokenLoginAction, 
            token, 
            logout,
            loginAction }}>{children}</AuthContext.Provider>
        </>
    ) ;
};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};